module.exports = __webpack_public_path__ + "img/P150T_weapon_150.bb02e5e7.png";